export function readFilterParams(keys) {
  const url = new URL(window.location.href)
  const result = {}
  keys.forEach(key => {
    result[key] = url.searchParams.get(key) || ""
  })
  return result
}

export function writeFilterParams(params) {
  const url = new URL(window.location.href)
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      url.searchParams.set(key, value)
    } else {
      url.searchParams.delete(key)
    }
  })
  window.history.replaceState({}, "", url.toString())
}
